import { render } from "./FeedbackCircle.vue?vue&type=template&id=28754049&scoped=true"
import script from "./FeedbackCircle.vue?vue&type=script&lang=js"
export * from "./FeedbackCircle.vue?vue&type=script&lang=js"

import "./FeedbackCircle.vue?vue&type=style&index=0&id=28754049&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28754049"]])

export default __exports__